import { useEffect, useState } from 'react'
import { isPhoneNumber } from '~/pages/WebPhone/utils/stringUtils'
import { SearchValue } from '~/types/Shared'
import {
  hasNoValueOrIsWhitespace,
  newUuid,
  tryGetValueOrDefault,
} from '~/utils/common'
import { formatPhoneNumber, getValidNumber } from '~/utils/formatter'

import { useSharedState } from '@mangovoice/core'

interface UseSearchInputStringParams {
  shareKey?: string
}
export const useSearchInputString = (props?: UseSearchInputStringParams) => {
  const { shareKey } = props || {}
  const [__sharedKey, __setSharedKey] = useState(
    tryGetValueOrDefault(shareKey, newUuid()),
  )

  const [searchValue, setSearchValue, _, deleteSearchValue] =
    useSharedState<SearchValue>({
      key: __sharedKey!,
      initialState: SearchValue.empty,
    })

  useEffect(() => {
    return () => {
      if (hasNoValueOrIsWhitespace(shareKey)) {
        deleteSearchValue()
      }
    }
  }, [])

  const getFormattedInput = (newSearchString: string) => {
    if (isPhoneNumber(newSearchString)) {
      const cleanNum = getValidNumber(newSearchString)
      const formattedNum = formatPhoneNumber(cleanNum)
      return { clean: cleanNum, formatted: formattedNum }
    } else {
      return { clean: newSearchString.trim(), formatted: newSearchString }
    }
  }

  const setInputString = (
    newString: string | ((prev: string) => string),
    autoFormatPhoneNumber: boolean = true,
  ): SearchValue => {
    const preFormatted =
      typeof newString === 'function' ? newString(searchValue.label) : newString

    const formatterOutput = autoFormatPhoneNumber
      ? getFormattedInput(preFormatted)
      : { clean: newString as string, formatted: newString as string }

    setSearchValue({
      value: formatterOutput.clean,
      label: formatterOutput.formatted,
    })

    return {
      value: formatterOutput.clean,
      label: formatterOutput.formatted,
    }
  }

  return {
    searchValue,
    setInputString,
    getFormattedInput,
  }
}
